import { useEffect, useState } from "react";
import { PageHeader, SimpleTable, Pager, Spinner } from "@/components/app/common";
import { api, dt, num } from "@/lib/api";
import { TX_TYPES } from "@/lib/labels";
import { cn } from "@/lib/utils";

export const TxTable = ({ rows, testid }) => (
  <SimpleTable testid={testid} rows={rows} empty="Henüz kredi hareketi yok." cols={[
    { key: "d", label: "Tarih", render: (t) => <span className="whitespace-nowrap">{dt(t.created_at)}</span> },
    { key: "t", label: "Tür", render: (t) => <span className="font-medium">{TX_TYPES[t.type] || t.type}{t.source === "ADMIN_MANUAL" && <span className="ml-1.5 text-[10px] text-muted-foreground">ADMIN_MANUAL</span>}</span> },
    { key: "desc", label: "Açıklama", render: (t) => <span className="text-muted-foreground">{t.description}</span> },
    { key: "a", label: "Miktar", render: (t) => <span className={cn("font-semibold", t.amount > 0 ? "text-emerald-500" : "text-rose-500")}>{t.amount > 0 ? "+" : ""}{num(t.amount)}</span> },
    { key: "b", label: "Bakiye", render: (t) => num(t.balance_after) },
  ]} />
);

export default function Transactions() {
  const [page, setPage] = useState(1);
  const [res, setRes] = useState(null);
  useEffect(() => { api.get("/me/transactions", { params: { page } }).then(({ data }) => setRes(data)); }, [page]);
  return (
    <div data-testid="transactions-page">
      <PageHeader title="Kredi Hareketleri" desc="Tüm kredi giriş ve çıkışlarınız." />
      {!res ? <Spinner /> : <><TxTable rows={res.items} testid="transactions-table" /><Pager page={res.page} pages={res.pages} onChange={setPage} /></>}
    </div>
  );
}
